// extracted by mini-css-extract-plugin
module.exports = {"nav":"Employees_nav__2Wnij","left":"Employees_left__3urhu","right":"Employees_right__30MQ0"};